module.exports = __webpack_public_path__ + "static/media/logo-black.8bef3ea8.svg";